/**
 * @author yan st
 * @date 2022-08-30 13:51
 * @Description:
 */

export const homeRouter = [
  {
    path: '',
    redirect: 'index'
  },
  {
    path: 'index',
    meta: {
      title: '首页',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/index'),
  },
  {
    path: 'orgDetail',
    meta: {
      title: '机构信息',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/orgDetail'),
  },
  {
    path: 'moneySupervision',
    meta: {
      title: '机构信息',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/moneySupervision'),
  },
  {
    path: 'orgOperation',
    meta: {
      title: '机构信息',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/orgOperation'),
  },
  {
    path: 'supervision',
    meta: {
      title: '机构信息',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/supervision'),
  },
  {
    path: 'riskWarning',
    meta: {
      title: '机构信息',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/riskWarning'),
  },
  {
    path: 'riskList',
    meta: {
      title: '风险预警',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/riskList'),
  },
  {
    path: 'historyList',
    meta: {
      title: '风险预警',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/historyList'),
  },
  {
    path: 'evaluateList',
    meta: {
      title: '星级评定',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/evaluateList'),
  },
  {
    path: 'evaluateAppealList',
    meta: {
      title: '星级评定',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/evaluateAppealList'),
  },
  {
    path: 'evaluateDetail',
    meta: {
      title: '星级评定',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/evaluateDetail'),
  },
  {
    path: 'publicizeList',
    meta: {
      title: '宣传信息',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/publicizeList'),
  },
  {
    path: 'publicizeNewsList',
    meta: {
      title: '宣传信息',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/publicizeNewsList'),
  },
  {
    path: 'policyList',
    meta: {
      title: '政策法规',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/policyList'),
  },
  {
    path: 'noticeList',
    meta: {
      title: '通知公告',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/noticeList'),
  },
  {
    path: 'detail',
    meta: {
      title: '详情',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/detail'),
  },
  {
    path: 'messageList',
    meta: {
      title: '消息提醒',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/messageList'),
  },
  {
    path: 'downloadList',
    meta: {
      title: '下载中心',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/downloadList'),
  },
  {
    path: 'password',
    meta: {
      title: '修改密码',
      needLogin: true // 是否需要登录才能访问
    },
    component: () => import('../views/home/pages/password'),
  },
]




export default homeRouter
